import { render, staticRenderFns } from "./LightningSvg.vue?vue&type=template&id=bd8f2716&"
import script from "./LightningSvg.vue?vue&type=script&lang=ts&"
export * from "./LightningSvg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('bd8f2716', component.options)
    } else {
      api.reload('bd8f2716', component.options)
    }
    module.hot.accept("./LightningSvg.vue?vue&type=template&id=bd8f2716&", function () {
      api.rerender('bd8f2716', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/premium/paywall/svgs/LightningSvg.vue"
export default component.exports